module.exports = __webpack_public_path__ + "static/media/S3N5-3.83c8a232.svg";